import React, { memo, SyntheticEvent } from 'react';
import {
  Conditional,
  Space,
  Textarea,
  Text,
  Checkbox,
  InputField,
} from '@cashfree-intl/coherent';

// Constants
import { SHARE_LOGIN_DETAILS_PLACEHOLDER, TEST_IDS } from '../constants';

// Types
import { WhitelistStepOneProps } from '../types';

const WhitelistStepOne = ({
  isWebsite,
  formikProps,
  isTest,
}: WhitelistStepOneProps) => {
  const inputLabel = isWebsite
    ? 'Business Website URL'
    : 'Play Store or Appstore link of app';
  let placeholder = isWebsite
    ? 'www.mycompany.com'
    : 'play.google.com/store/apps/details';
  if (!isTest) placeholder = 'https://' + placeholder;
  const {
    values,
    handleFieldChange,
    handleFieldBlur,
    errors,
    touched,
    setFieldValue,
  } = formikProps;
  const onCheckboxChange = (_e: SyntheticEvent, data: { checked: boolean }) => {
    setFieldValue('loginAvailable', data.checked);
  };
  return (
    <Space direction="column" data-testid={TEST_IDS.WHITELIST_STEP_ONE}>
      <InputField
        label={inputLabel}
        name="channelValue"
        placeholder={placeholder}
        value={values.channelValue}
        onChange={handleFieldChange}
        onBlur={handleFieldBlur}
        errors={errors}
        touched={touched}
      />
      <Checkbox
        name="loginAvailable"
        label="Share login details to test & verify"
        className="custom-checkbox mb-2 mt-2"
        checked={values.loginAvailable}
        onChange={onCheckboxChange}
      />
      <Conditional if={values.loginAvailable}>
        <Textarea
          rows={4}
          fluid
          name="testCredentials"
          placeholder={SHARE_LOGIN_DETAILS_PLACEHOLDER}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
          className="ml-3"
          data-testid="comment-textarea"
          value={values.testCredentials}
        />
        <Text variant="b12" color="danger" className="ml-3">
          {errors.testCredentials}
        </Text>
      </Conditional>
    </Space>
  );
};

export default memo(WhitelistStepOne);
